/* eslint-disable arrow-parens */
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TooltipViewPropTypes = {
  children: PropTypes.node, // Can be plain text or additional markup for aesthetic reasons
  handleClick: PropTypes.func.isRequired, // Toggles the tooltip
  toggle: PropTypes.bool.isRequired, // State of the tooltip
};

const TooltipViewDefaultProps = {
  children: null,
};

// eslint-disable-next-line arrow-parens
const TooltipView = props => {
  // eslint-disable-next-line object-curly-newline
  const { handleClick, children, toggle } = props;

  return (
    <div
      role="button"
      tabIndex="0"
      onClick={e => handleClick(e)}
      className={classNames('tsla-twotip', {
        'tsla-twotip--visible': toggle,
      })}
    >
      <div className="tsla-twotip__body tsla-twotip--top">
        <div className="tsla-twotip__icon">
          <i className="tsla-icon-close--circle" />
        </div>
        {children.map(child => (
          <p>{child}</p>
        ))}
      </div>
      <i className="tsla-icon-info--circle" />
    </div>
  );
};

TooltipView.propTypes = TooltipViewPropTypes;

TooltipView.defaultProps = TooltipViewDefaultProps;

export default TooltipView;
